import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class PageLoadBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.load;
        this.handler = () => { };
    }
    getWebGlInfo() {
        var _a;
        try {
            const canvas = document.createElement("canvas");
            const gl = (canvas.getContext("webgl") ||
                canvas.getContext("experimental-webgl"));
            if (gl == null) {
                return null;
            }
            const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
            const vendor = gl.getParameter(debugInfo != null ? debugInfo.UNMASKED_VENDOR_WEBGL : gl.VENDOR);
            const renderer = gl.getParameter(debugInfo != null ? debugInfo.UNMASKED_RENDERER_WEBGL : gl.RENDERER);
            (_a = gl.getExtension("WEBGL_lose_context")) === null || _a === void 0 ? void 0 : _a.loseContext();
            return { vendor, renderer };
        }
        catch (err) {
            return null;
        }
    }
    getTimezone() {
        try {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }
        catch (err) {
            return null;
        }
    }
    start() {
        var _a;
        const { innerWidth, innerHeight, screen } = window;
        const { width, height, orientation, availHeight, availWidth } = screen;
        const screenOrientation = {
            angle: orientation.angle,
            type: orientation.type,
        };
        const { userAgent } = navigator;
        const deviceInfo = {
            hardwareConcurrency: navigator.hardwareConcurrency,
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            vendor: navigator.vendor,
            appVersion: navigator.appVersion,
            screen: {
                width: screen.width,
                height: screen.height,
                orientation: screenOrientation,
                availWidth: screen.availWidth,
                availHeight: screen.availHeight,
            },
            pdfViewerEnabled: navigator.pdfViewerEnabled,
            timezoneOffset: new Date().getTimezoneOffset(),
            timezone: this.getTimezone(),
            language: navigator.language,
            languages: navigator.languages,
            webdriver: (_a = navigator.webdriver) !== null && _a !== void 0 ? _a : null,
            pluginsCount: navigator.plugins != null ? navigator.plugins.length : null,
            webGl: this.getWebGlInfo(),
        };
        if (navigator.deviceMemory != null) {
            deviceInfo.deviceMemory = navigator.deviceMemory;
        }
        const extraMetadata = {
            width,
            height,
            orientation: screenOrientation,
            availHeight,
            availWidth,
            innerWidth,
            innerHeight,
            userAgent,
            buildVersion: this.plasm.config.buildVersion,
            deviceInfo,
        };
        if ("isExtended" in screen) {
            extraMetadata.isExtended = window.screen.isExtended;
        }
        this.plasm.debug(`Behavior ${this.id} started`);
        this.addLog(new Event(this.id), this.id, extraMetadata);
    }
}
export default PageLoadBehavior;
